import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import GamePage from './pages/GamePage';
import ModDetails from './pages/ModDetails';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/game/:gameId" element={<GamePage />} />
            <Route path="/game/:gameId/mod/:modId" element={<ModDetails />} />
          </Routes>
        </main>
        <footer className="footer">
          <p>Made by Kezza4K</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
